import { NgModule } from '@angular/core';
import { SharedModule } from '@common/shared/shared.module';

// TODO Need to get how's it work, and delete this module

@NgModule({
  imports: [SharedModule]
})
export class NotificationsModule {}
